// extracted by mini-css-extract-plugin
module.exports = {"Index":"Index_Index__2bN4N","Text-Orange":"Index_Text-Orange__37XdC"};